import React from "react";
import ReactApexChart from "react-apexcharts";

const ApexLineMainDomains = ({ series, categories }) => {
  const options = {
    chart: {
      height: 350,
      type: "line",
      toolbar: { show: false },
    },
    stroke: {
      width: 5,
      curve: "smooth",
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: categories,
      title: { text: "الدفعات" },
    },
    yaxis: {
      labels: {
        show: false,
      },
      axisTicks: {
        show: true, // ← يخفي علامات التدرج
      },
      axisBorder: {
        show: false, // ← يخفي خط المحور نفسه
      },
    },
    legend: {
      position: "top",
      labels: {
        style: {
          fontFamily: "Cairo",
          fontSize: "14px",
          fontWeight: 500,
        },
      },
    },
    markers: {
      size: 10,
      strokeWidth: 4,
      hover: {
        size: 14,
      },
    },

    colors: ["#00E396", "#FEB019", "#FF4560", "#775DD0", "#008FFB"],
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default ApexLineMainDomains;
